export default "__VITE_ASSET__kuVWCJhL__"